<template>
  <div id="match-invite">
    <comp-header
      :pageTitle="headerPageTitle"
      :leftIcon="headerLeftIcon"
      :leftClick="headerLeftAction"
      :rightIcon="headerRightIcon"
      :rightClick="headerRightAction"
    >
    </comp-header>
    <comp-invite-group
      :groupId="this.$route.query.groupId"
      @stopLoading="stopLoading"
      @urlAdd="urlAdd"
      @performMatch="goGroupQRPage"
      @performQr="goQrReader"
      @myFriend="goFriendList"
    />
    <comp-modal v-if="copyModal" @confirm="copyModal = !copyModal">
      <p slot="body" v-html="copyModalMsg" />
    </comp-modal>
    <comp-loading v-if="isLoading" />
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompInviteGroup from '@/components/CompInviteGroup';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'match-invite',
  mixins: [common],
  components: {
    CompHeader,
    CompInviteGroup,
    CompModal,
    CompLoading,
  },
  data() {
    return {
      headerPageTitle: this.$i18n.t('match.inviteMember'),
      headerLeftIcon: 'fa-chevron-left',
      headerRightIcon: '',

      copyModal: false,
      copyModalMsg: '',
      isLoading: false,
    };
  },
  methods: {
    headerLeftAction() {
      if (this.$route.query.openType === 'clearTop') {
        return;
      }
      this.goPrevious();
    },
    headerRightAction() {
      if (this.$route.query.openType === 'clearTop') {
        this.goPrevious();
      }
    },
    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    },
    urlAdd(link) {
      this.textCopy(link);
      this.showModal = false;
      this.copyModalMsg = this.$i18n.t('friends.urlCopy');
      this.copyModal = true;
    },
    goGroupQRPage() {
      this.$router.push({
        name: 'match-qr',
        params: {
          type: 'groupQr',
          groupId: this.$route.query.groupId,
        },
      });
    },
    goQrReader() {
      this.$router.push({
        name: 'match-qr',
        params: {
          type: 'groupScan',
          groupId: this.$route.query.groupId,
        },
      });
    },
    goFriendList() {
      this.$router.push({
        path: '/match/group',
        query: {
          groupId: this.$route.query.groupId,
          groupName: this.$route.query.groupName,
          type: 'invite',
        },
      });
    },
  },
  created() {
    if (this.$route.query.openType === 'clearTop') {
      this.headerLeftIcon = '';
      this.headerRightIcon = 'fa-times';
    } else {
      this.headerLeftIcon = 'fa-chevron-left';
      this.headerRightIcon = '';
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/match/match-invite.vue